// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"707116ca","845":"cec2c1e1"}[chunkId] + ".chunk.js";
};